export class MapHook {
    constructor() {
        this.defaultLayerState = {};
        this.resize = () => { };
        this.flyTo = () => { };
    }
}
